"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = require("../utils/index.js");
var _initDataLayer = _interopRequireDefault(require("./initDataLayer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var pushEventToDataLayer = function pushEventToDataLayer(event) {
  var dataLayer = (0, _initDataLayer["default"])();
  var cleanedEvent = (0, _index.removeEmptyKeys)(event);
  dataLayer.push(cleanedEvent);
};
var _default = exports["default"] = pushEventToDataLayer;